import { AutoFocusTarget } from '@angular/cdk/dialog';
import { ComponentType } from '@angular/cdk/portal';
import { Binding, Injectable, Injector, TemplateRef } from '@angular/core';
import { MatDrawerMode } from '@angular/material/sidenav';
import { SideSheetSide } from '@libs/common/models';
import { Subject } from 'rxjs';
import { CreateSideSheetComponentData, CreateSideSheetTemplateData } from './api';

@Injectable({ providedIn: 'root' })
export class SideSheetService {
  public createSideSheetWithComponent$: Subject<CreateSideSheetComponentData> = new Subject();
  public createSideSheetWithTemplate$: Subject<CreateSideSheetTemplateData> = new Subject();

  public closeSideSheet$: Subject<SideSheetSide> = new Subject();

  public createSideSheetWithComponent<T>(
    side: SideSheetSide,
    component: ComponentType<T>,
    inputs: Binding[],
    mode?: MatDrawerMode,
    width?: string,
    autoFocusTarget?: AutoFocusTarget,
    injector?: Injector,
  ): void {
    this.createSideSheetWithComponent$.next({
      side: side,
      mode: mode,
      componentCtr: component,
      inputs: inputs,
      width: width,
      autoFocusTarget: autoFocusTarget,
      injector: injector,
    });
  }

  public createSideSheetWithTemplate(
    side: SideSheetSide,
    template: TemplateRef<unknown>,
    mode?: MatDrawerMode,
    width?: string,
    autoFocusTarget?: AutoFocusTarget,
  ): void {
    this.createSideSheetWithTemplate$.next({
      side: side,
      mode: mode,
      template: template,
      width: width,
      autoFocusTarget: autoFocusTarget,
    });
  }

  public closeSideSheet(side: SideSheetSide): void {
    this.closeSideSheet$.next(side);
  }
}
